import React, { useCallback, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import styles from '../../../styles/layout.module.css';
import { Breadcrumb, Button, Divider, Input, Row, Space, Spin, Typography } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import EditableField from '../../fields/EditableField';
import { DeleteOutlined, ShopTwoTone } from '@ant-design/icons';
import { CompanyLocation } from '../../../features/locations/locations.types';
import { Language } from '../../../features/languages/languages.types';
import { useLanguageByCode } from '../../../features/languages/languages.hooks';
import { deleteLanguage, fetchLanguage, updateLanguage } from '../../../features/languages/languages.state';

const LanguagePage: React.FC = () => {
  const { languageCode } = useParams() as { languageCode: string };
  const dispatch = useDispatch();
  const language = useLanguageByCode(languageCode) as Language;

  const handleDeleteButtonClick = useCallback(() => {
    dispatch(deleteLanguage({ languageCode }));
  }, [dispatch, languageCode]);

  const handleLocationUpdate = useCallback(
    (data: Partial<CompanyLocation>) => {
      dispatch(updateLanguage({ languageCode, data }));
    },
    [dispatch, languageCode]
  );

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/languages'>
                <Space>
                  <ShopTwoTone />
                  Языки
                </Space>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/settings/languages/${languageCode}`}>{language.name}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            {language.name}
          </Typography.Title>
          <Space size='small' />
        </div>
        <div className={styles.sidebar}>
          <div className={styles.propertiesGrid}>
            <Typography.Text className={styles.title}>Код</Typography.Text>
            <EditableField value={language.code}>
              <Input
                type='text'
                name='code'
                placeholder='Введите код языка'
                onBlur={ev => handleLocationUpdate({ code: ev.target.value })}
              />
            </EditableField>
          </div>
          <Divider />
          <Space direction='vertical' size='small'>
            <Button type='link' onClick={handleDeleteButtonClick} danger size='small' style={{ padding: 0 }}>
              <DeleteOutlined /> Удалить язык
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

const LanguagePageBlock: React.FC = () => {
  const { languageCode } = useParams() as { languageCode: string };
  const dispatch = useDispatch();
  const language = useLanguageByCode(languageCode);

  useEffect(() => {
    dispatch(fetchLanguage({ languageCode }));
  }, [dispatch, languageCode]);

  if (!language) {
    return (
      <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
        <Spin size={'large'} />
      </Row>
    );
  }

  return <LanguagePage />;
};

export default LanguagePageBlock;
